'use client';

import React, { useState } from 'react';

export default function PodcastClientGrid({ podcasts }: { podcasts: any[] }) {
  const [activeVideo, setActiveVideo] = useState<string | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;

  if (podcasts.length === 0) {
    return (
      <div className="col-span-full text-center py-20" style={{ gridColumn: '1 / -1' }}>
        <h2 className="text-2xl font-bold" style={{ fontSize: '1.5rem', color: '#6b1122' }}>Nenhum podcast encontrado no momento.</h2>
        <p className="mt-2" style={{ color: '#555' }}>Volte novamente mais tarde!</p>
      </div>
    );
  }

  const totalPages = Math.ceil(podcasts.length / itemsPerPage);
  const currentPodcasts = podcasts.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <>
      {currentPodcasts.map((p: any) => {
        const vid = p.id.videoId;
        const thumb = p.snippet.thumbnails?.high?.url || p.snippet.thumbnails?.medium?.url;
        return (
          <div key={vid} onClick={() => setActiveVideo(vid)} className="cgt-card-podcast" style={{ cursor: 'pointer' }}>
            <div className="cgt-card-img-wrap">
              <div className="cgt-card-tipo">
                <svg width="12" height="12" fill="currentColor" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" /></svg>
                YOUTUBE
              </div>
              <img src={thumb} alt={p.snippet.title} className="cgt-card-img" />
              <div className="cgt-card-play">
                <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M8 5v14l11-7z" /></svg>
              </div>
            </div>
            <div className="cgt-card-content">
              <div className="cgt-card-meta">
                <span>📅</span>
                {new Date(p.snippet.publishedAt).toLocaleDateString('pt-BR')}
              </div>
              <h3 className="cgt-card-title">{p.snippet.title.replace(/&quot;/g, '"')}</h3>
              <p className="cgt-card-resumo">{p.snippet.description}</p>
              <div className="cgt-card-btn">Assistir Episódio <span>→</span></div>
            </div>
          </div>
        );
      })}

      {totalPages > 1 && (
        <div style={{ gridColumn: '1 / -1', display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '30px' }}>
          <button 
            onClick={() => { setCurrentPage(prev => Math.max(prev - 1, 1)); window.scrollTo({ top: 400, behavior: 'smooth' }); }}
            disabled={currentPage === 1}
            style={{ padding: '10px 20px', background: currentPage === 1 ? '#ccc' : '#6b1122', color: '#fff', border: 'none', borderRadius: '4px', cursor: currentPage === 1 ? 'not-allowed' : 'pointer', fontWeight: 'bold' }}
          >
            Anterior
          </button>
          <span style={{ display: 'flex', alignItems: 'center', fontWeight: 'bold', color: '#555' }}>
            Página {currentPage} de {totalPages}
          </span>
          <button 
            onClick={() => { setCurrentPage(prev => Math.min(prev + 1, totalPages)); window.scrollTo({ top: 400, behavior: 'smooth' }); }}
            disabled={currentPage === totalPages}
            style={{ padding: '10px 20px', background: currentPage === totalPages ? '#ccc' : '#6b1122', color: '#fff', border: 'none', borderRadius: '4px', cursor: currentPage === totalPages ? 'not-allowed' : 'pointer', fontWeight: 'bold' }}
          >
            Próxima
          </button>
        </div>
      )}

      {activeVideo && (
        <div className="cgt-modal-overlay" onClick={() => setActiveVideo(null)}>
          <div className="cgt-modal-content" onClick={e => e.stopPropagation()}>
            <button className="cgt-modal-close" onClick={() => setActiveVideo(null)}>×</button>
            <div className="cgt-video-container">
              <iframe 
                src={`https://www.youtube-nocookie.com/embed/${activeVideo}?autoplay=1`} 
                frameBorder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
